var map = {
	"./fortuneIcon.svg": 696,
	"./fortuneIconL.svg": 697,
	"./helpdeskIcon.svg": 698,
	"./helpdeskIconL.svg": 699,
	"./homeIcon.svg": 700,
	"./homeIconLarge.svg": 701,
	"./jackpotIcon.svg": 702,
	"./logo.svg": 703,
	"./logoSmall.svg": 704,
	"./loyaltyIcon.svg": 705,
	"./mobileAppIcon.svg": 706,
	"./profileIcon.svg": 707,
	"./questIcon.svg": 708,
	"./questsIcon.svg": 709,
	"./rewardLineupIcon.svg": 710,
	"./searchIcon.svg": 711,
	"./searchIconLarge.svg": 712,
	"./signOutIcon.svg": 713,
	"./star.svg": 714,
	"./tournamentIcon.svg": 715,
	"./tournamentLargeIcon.svg": 716,
	"./vipIcon.svg": 717,
	"./wheelIcon.svg": 718,
	"./wheelIconL.svg": 719,
	"./wheelIconMobile.svg": 720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 695;